import { Component, signal } from '@angular/core';
import { EventFormComponent } from "@app/components/forms/event/form.component";
import { EventHelperService } from '@app/services/helpers/event-helper.service';
import { Router, RouterModule } from '@angular/router';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { EventCreate } from '@app/models/event.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { HeadMetaComponent } from '@app/components/ui.component';
import { ToastService } from '@app/services/toast.service';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-event-create',
    templateUrl: './create.page.html',
    styleUrl: './create.page.scss',
    imports: [
        HeadMetaComponent,
        EventFormComponent,
        RouterModule,
        FontAwesomeModule,
        HelpButtonComponent
    ]
})
export class EventCreatePage {
  public title = 'New Event';
  formValid = signal(false);
  formValue = signal<EventCreate | null>(null);

  faArrowLeft = faArrowLeft;

  constructor(
    private eventService: EventHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    
  }

  create() {
    let val = this.formValue();
    if(val) {
      this.eventService.create(val)
        .subscribe({
          next: id => {
            console.log(id)
            if(id) {
              this.router.navigateByUrl('/events/' + id);
            }
          },
          error: (err: AppHttpError) => {
            console.log(err.error)
            this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
          }
        });
    }
  }
}
